import React from "react";
import CloseBtn from "./CloseBtn";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
export default function Header(props) {
  const headerIconColor = props.headerIconColor ? props.headerIconColor : '#2db742',
        headerIcon = props.headerIcon ? /*#__PURE__*/React.createElement("img", {
    src: props.headerIcon,
    alt: "chat_logo",
    width: "52",
    height:"140",
  }) : /*#__PURE__*/React.createElement(WhatsAppIcon, {
    headerIconColor: headerIconColor,
    style:{
      width: "52px",
    height:"140px",
    }
  }),
        headerIconBgColor = props.headerIconBgColor ? props.headerIconBgColor : '#2db742',
        headerTxtColor = props.headerTxtColor ? props.headerTxtColor : '#d9ebc6',
        headerBgColor = props.headerBgColor ? props.headerBgColor : '#2db742',
        headerTitle = props.headerTitle ? props.headerTitle : 'Start a Conversation',
        headerCaption = props.headerCaption ? props.headerCaption : '';
  return /*#__PURE__*/React.createElement("div", {
    key: props,
    className: "whatsapp_widget_header",
    style: {
      backgroundColor: headerBgColor,
      color: headerTxtColor
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "whatsapp_widget_header_close_btn"
  }, /*#__PURE__*/React.createElement(CloseBtn, null)), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "whatsapp_widget_header_icon",
    style: {
      backgroundColor: headerIconBgColor
    }
  }, headerIcon), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 16
    }
  }, headerTitle), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12
    }
  }, headerCaption))));
}